import Http from './http';
import store from 'store';

class DocumentTypesService {
    constructor() {
        this.documentTypes = null;
        this.documentTypesTree = null;
    }

    resetCache(){
        if (!this.documentTypes) return;
        store.set('documentTypes', false);
        store.set('documentTypesTree', false);
        this.documentTypes = null;
        this.documentTypesTree = null;
        this.getDocumentTypes()
    }

    prepareTree(data) {
        const structure = {
            'Regulatory Developments': ['Consultation', 'Guidance', 'Policy', 'Regulation', 'Standard', 'Statement'],
            'Corporate Communications': ['Press Release', 'Business Plan', 'Speech', 'Report', 'Warning', 'Parliamentary Commentary'],
            'Enforcements': ['Enforcement', 'Industry Letter']
        };

        const tree = [];

        for (let i in structure) {
            const item = { 
                label: i, 
                value: 'parent-' + i.replace(' ', '-').toLowerCase(), 
                children: data.filter(el => structure[i].includes(el.label))
            };
            tree.push(item);
        }
        return tree;
    }

    getDocumentTypes() {
        return new Promise((resolve, reject) => {
            if (store.get('documentTypes', false)){
                this.documentTypes = store.get('documentTypes');
                this.documentTypesTree = store.get('documentTypesTree');
            }
            if (this.documentTypes && this.documentTypesTree) {
                resolve({ documentTypes: this.documentTypes, documentTypesTree: this.documentTypesTree });
            }
            else {
                Http.get('/document-categories/').then(resp => {
                    this.documentTypes = resp.data;
                    this.documentTypesTree = this.prepareTree(resp.data.categories);
                    store.set('documentTypes', this.documentTypes);
                    store.set('documentTypesTree', this.documentTypesTree);
                    resolve({ documentTypes: this.documentTypes, documentTypesTree: this.documentTypesTree });
                });
            }
        })
    }
}

export default new DocumentTypesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/documentTypes.js